var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 21.9436V19.9436C19.5 18.8827 19.0786 17.8653 18.3284 17.1152C17.5783 16.365 16.5609 15.9436 15.5 15.9436H9.5C8.43913 15.9436 7.42172 16.365 6.67157 17.1152C5.92143 17.8653 5.5 18.8827 5.5 19.9436V21.9436",
    stroke: "#ABABAB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 11.9436C14.7091 11.9436 16.5 10.1527 16.5 7.9436C16.5 5.73446 14.7091 3.9436 12.5 3.9436C10.2909 3.9436 8.5 5.73446 8.5 7.9436C8.5 10.1527 10.2909 11.9436 12.5 11.9436Z",
    stroke: "#ABABAB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileicon);
export default __webpack_public_path__ + "static/media/profileicon.5587fb566a69fa472b15f1dd5b2f207a.svg";
export { ForwardRef as ReactComponent };